import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import { Images } from './imageConstants'

type SuccessDialogOpts = {
  title?: string;                      // heading
  subtitle?: string;                   // small paragraph
  seconds?: number;                    // countdown seconds
  onProceed?: () => void;              // when PROCEED NEXT or countdown finishes
  onBackToHome?: () => void;           // when BACK TO HOME clicked (defaults to onProceed if not set)
};

export function showTournamentSuccess({
  title = "Tournament Created Successfully!",
  subtitle = "Your tournament is officially created! Now it’s time to bring it to life by adding teams, players, and fixtures—get everything ready for the action ahead.",
  seconds = 3,
  onProceed,
  onBackToHome,
}: SuccessDialogOpts) {
  const handleBackToHome = onBackToHome ?? onProceed;
  confirmAlert({
    closeOnClickOutside: false,
    closeOnEscape: false,
    customUI: ({ onClose }) => {
      const SuccessBody: React.FC = () => {
        const [count, setCount] = useState(seconds);

        useEffect(() => {
          const t = setInterval(() => {
            setCount((c) => {
              if (c <= 1) {
                clearInterval(t);
                onClose();
                onProceed?.();
                return 0;
              }
              return c - 1;
            });
          }, 1000);
          return () => clearInterval(t);
        }, []);

        const handleProceed = () => {
          onClose();
          onProceed?.();
        };

        const handleBack = () => {
          onClose();
          handleBackToHome?.();
        };

        return (
          <div className="react-confirm-alert-body success-dialog">
            <div className="success-icon-wrap">
              <div className="success-icon">
               <img src={Images.success_icon} alt="successIcon"/>
                <div className="confetti"></div>
              </div>
            </div>

            <h2 className="success-title">{title}</h2>
            <p className="success-subtitle">{subtitle}</p>

            <div className="react-confirm-alert-button-group success-actions">
              <button type="button" className="success-btn success-btn-outline" onClick={handleBack}>
                BACK TO HOME
              </button>
              <button type="button" className="success-btn" onClick={handleProceed}>
                PROCEED NEXT ({count}s)
              </button>
            </div>
          </div>
        );
      };
      return <SuccessBody />;
    },
  });
}

export function showCreateLeagueSuccess({
  title = "League Created Successfully!",
  subtitle = "Your league is officially created! Now it's time to bring it to life by creating tournament, teams, players, and fixtures—get everything ready for the action ahead.",
  seconds = 3,
  onProceed,
}: SuccessDialogOpts) {
  showTournamentSuccess({ title, subtitle, seconds, onProceed });
}

export function showGroundCreatedSuccess({
  title = "Ground Created Successfully!",
  subtitle = "Your Grounds are officially created! Now it's time to bring it to life by adding teams, players, and fixtures—get everything ready for the action ahead.",
  seconds = 3,
  onProceed,
  onBackToHome,
}: SuccessDialogOpts) {
  showTournamentSuccess({ title, subtitle, seconds, onProceed, onBackToHome });
}

